module.exports = __webpack_public_path__ + "static/img/COOPER-DUFF-TYTLER.bb90083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COOPER-DUFF-TYTLER.jpg
// module id = TjNl
// module chunks = 0